export default "__VITE_ASSET__CLwN4is4__"